import { Grid } from '@mui/material';
import { FC, useState } from 'react';
import {
  SMBSelect,
  NeighborhoodLotsDropdown,
  FiltersButtons,
  FiltersLayout
} from '../../../components';
import { getSalesBuildStatuses } from '../../../fetch/lookups';
import { IBuildStatus } from '../../../models';
import { SalesNeighborhoodDropdown } from '../../../components/dropdowns/sales-neighborhood-dropdown';

interface IPlanFinderFilters {
  applyFilters: (clearFilters?: boolean) => void;
  selectedStatus: string;
  setSelectedStatus: (val: string) => void;
  selectedLotId: string;
  setSelectedNeighborhoodId: (val: any) => void;
  setSelectedLotId: (val: any) => void;
  selectedNeighborhoodId: string;
  isLoading: boolean;
}

export const PlanFinderFilters: FC<IPlanFinderFilters> = ({
  applyFilters,
  selectedStatus,
  setSelectedStatus,
  selectedNeighborhoodId,
  selectedLotId,
  setSelectedNeighborhoodId,
  setSelectedLotId,
  isLoading
}) => {
  const [hasAppliedFilters, setHasAppliedFilters] = useState<boolean>(false);

  return (
    <FiltersLayout>
      <Grid item xs={12} sm={6} lg={4} xl={3}>
        <SalesNeighborhoodDropdown
          value={selectedNeighborhoodId}
          handleChange={value => {
            setSelectedNeighborhoodId(value);
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6} lg={4} xl={3}>
        <NeighborhoodLotsDropdown
          value={selectedLotId}
          isDisabled={!selectedNeighborhoodId}
          handleChange={value => setSelectedLotId(value)}
          apiParams={{ neighborhoodId: selectedNeighborhoodId }}
        />
      </Grid>
      <Grid item xs={12} sm={6} lg={4} xl={3}>
        <SMBSelect
          label="Status"
          value={selectedStatus}
          handleClear={() => {
            setSelectedStatus('');
          }}
          shouldFetch
          onChange={e => setSelectedStatus(e.target.value)}
          apiRequest={() => getSalesBuildStatuses()}
          transformResponse={(res: IBuildStatus[]) =>
            res.map(r => ({
              label: r.description,
              value: `${r.value}`
            }))
          }
        />
      </Grid>
      <Grid item xs={12} sm={5} xl={3}>
        <FiltersButtons
          hasAppliedFilters={hasAppliedFilters}
          isDisabled={isLoading}
          handleApplyFilters={() => {
            setHasAppliedFilters(true);
            applyFilters();
          }}
          handleResetFilters={() => {
            setHasAppliedFilters(false);
            setSelectedNeighborhoodId('');
            setSelectedLotId('');
            setSelectedStatus('');
            applyFilters(true);
          }}
        />
      </Grid>
    </FiltersLayout>
  );
};
